import { render } from "./ShareInfo.vue?vue&type=template&id=295c37ae&scoped=true"
import script from "./ShareInfo.vue?vue&type=script&lang=js"
export * from "./ShareInfo.vue?vue&type=script&lang=js"

import "./ShareInfo.vue?vue&type=style&index=0&id=295c37ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295c37ae"]])

export default __exports__